// @flow
import { filter, concat, isEmpty, get } from 'lodash';
import { StringUtil } from 'utils/StringUtil';
import { CommonMapper } from 'mappers/common';
import { CampaignSelector } from 'modules/campaign/selector';

const getPageData = state => {
  return state.CmsPagesReducer.pageBanner;
};

const getPageDataLoading = state => {
  return state.CmsPagesReducer.loading.pageBanner;
};

const getPageDataError = state => {
  return state.CmsPagesReducer.error.pageBanner;
};

const getPageDataMobile = state => {
  return formatBeliefStatementsMobile(state.CmsPagesReducer.pageBanner);
};

const getCampaignDataMobile = state => {
  return formatCampaignMobile(state);
};

const getOurDifferenceSection = (state, type, parentPageTitle, verticalId) => {
  const pageBanner = state.CmsPagesReducer.pageBanner;
  if (!pageBanner || pageBanner.length === 0) {
    return null;
  }
  return formatOurDifferenceData(pageBanner, type, parentPageTitle, verticalId);
};

const getVisionPhilosophy = (state, name, vertical, isVertical) => {
  return formatVisionPhilosophy(
    state.CmsPagesReducer.pageBanner,
    name,
    vertical,
    isVertical
  );
};
const getMusicFoundation = (state, parentPageTitle, type, isVertical) => {
  return formatMusicFoundation(
    state.CmsPagesReducer.pageBanner,
    parentPageTitle,
    type,
    isVertical
  );
};
const getRentalHome = (state, pageTitle, type, isVertical) => {
  return formatRentalHome(
    state.CmsPagesReducer.pageBanner,
    pageTitle,
    type,
    isVertical
  );
};

const getCmsPages = (state, title, pageTitle, campaignId) => {
  return formatCmsPages(
    state.CmsPagesReducer.pageBanner,
    title,
    pageTitle,
    campaignId
  );
};

const isCmsPageLoading = state => {
  return getPageDataLoading(state);
};

const formatCmsPages = (cmsData, title, pageTitle, campaignId) => {
  let sectionData = [];
  const mediaPath = CommonMapper.extractMediaPath(cmsData);
  if (pageTitle) {
    sectionData = cmsData && checkPageTitle(cmsData, title);
  } else if (!pageTitle) {
    sectionData = cmsData && checkParentPageTitle(cmsData, title, campaignId);
  }
  return sectionData && mapCmsPageFields(sectionData, mediaPath, title);
};

const checkPageTitle = (cmsData, title) => {
  let pageData = [];
  pageData = filter(
    cmsData.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].page_title.includes(title)
  );

  return pageData;
};

const checkParentPageTitle = (cmsData, title, campaignId) => {
  let pageData = [];
  pageData = filter(
    cmsData && cmsData.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === title
  );
  if (campaignId) {
    pageData = pageData.filter(id => id.campaign_id === campaignId);
  }

  return pageData;
};

const mapCmsPageFields = (sectionData, mediaPath, title) => {
  let cmsPageData = '';

  if (sectionData.length > 0) {
    sectionData.map((data, idx) => {
      cmsPageData = {
        heading: data.cms_page_details[0].page_title,
        tag_word: data.tag_word,
        sub_heading: data.cms_page_details[0].short_content,
        paragraph: data.cms_page_details[0].long_content,
        sub_heading_mobile: data.cms_page_details[0].short_mobile_content,
        paragraph_mobile: data.cms_page_details[0].long_mobile_content,
        image: `${mediaPath.web}/${data.image}`,
        image_mobile: `${mediaPath.mobile}/${data.mobile_image}`,
        image_thumbnail: `${mediaPath.thumbnail}/${data.image}`,
        video: data.video,
        video_thumbnail_url: data.video_thumbnail_url
          ? data.video_thumbnail_url
          : '',
      };
    });

    return cmsPageData;
  }

  return [];
};

const formatBeliefStatementsMobile = data => {
  let results = [];
  let cmsData = [];
  const mediaPath = CommonMapper.extractMediaPath(data);
  cmsData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === 'Belief Statements'
  );
  cmsData.map((data, index) => {
    const sectionData = {
      image_mobile: `${mediaPath.mobile}/${data.mobile_image}`,
      heading: data.tag_word,
      sub_heading: data.cms_page_details[0].page_title,
      paragraph: data.cms_page_details[0].short_mobile_content,
    };
    results.push(sectionData);
  });
  return results;
};

const formatCampaignMobile = state => {
  let data = state.CmsPagesReducer.pageBanner;
  let results = [],
    cmsData = [];
  const campaignDetails = CampaignSelector.getCampaignDetails(state);
  const campaignId = get(campaignDetails[0], 'id', '');
  cmsData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === 'Campaign'
  );
  if (cmsData.length > 0) {
    cmsData = filter(
      cmsData,
      extractedData => extractedData.campaign_id === campaignId
    );
    const mediaPath = CommonMapper.extractMediaPath(data);
    cmsData.map((data, index) => {
      const sectionData = {
        image_mobile: `${mediaPath.mobile}/${data.mobile_image}`,
        heading: data.tag_word,
        sub_heading: data.cms_page_details[0].page_title,
        paragraph: data.cms_page_details[0].short_mobile_content,
      };
      results.push(sectionData);
    });
    return results;
  }
};

const formatOurDifferenceData = (data, type, parentPageTitle, verticalId) => {
  const path = data && data.media_path;
  const web = data && data.device && data.device.web;
  const mobile = data && data.device && data.device.mobile;
  const thumbnail = data && data.device && data.device.thumbnail;

  const sectionData = [];
  let cmsData = [],
    pageData = [],
    cms_parent_details = [];

  cmsData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === parentPageTitle
  );

  cms_parent_details = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].page_title === parentPageTitle
  );

  if (type === 'our-difference') {
    let temp_our_diff = [];
    temp_our_diff = concat(cms_parent_details, cmsData);
    if (verticalId) pageData = checkVertical(temp_our_diff, verticalId);
    else pageData = temp_our_diff;
  }
  if (type === 'culture-leadership') {
    pageData = concat(cms_parent_details, cmsData);
  }

  if (type === 'design-services') {
    let temp_our_diff = [];
    temp_our_diff = concat(cms_parent_details, cmsData);
    pageData = checkVertical(temp_our_diff, verticalId);
  }
  pageData.map((data, idx) => {
    const ourDifferenceData = {
      id: data.id,
      tag_word: data.tag_word,
      image: `${path}${web}/${data.image}`,
      mobile_image: `${path}${mobile}/${data.mobile_image}`,
      thumbnail: `${path}${thumbnail}/${data.image}`,
      page_title: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].page_title
        : '',
      parent_page_title: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].parent_page_title
        : '',
      short_content: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].short_content
        : '',
      long_content: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].long_content
        : '',
      short_mobile_content: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].short_mobile_content
        : '',
      long_mobile_content: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].long_mobile_content
        : '',
      cms_page_id: !isEmpty(data.cms_page_details)
        ? data.cms_page_details[0].cms_page_id
        : '',
      media_path: `${path}${web}`,
      media_path_mobile: `${path}${mobile}`,
    };
    sectionData.push(ourDifferenceData);
  });
  return sectionData;
};

const checkVertical = (temp_data, verticalId) => {
  let result = [];
  temp_data.forEach(data => {
    if (data.vertical_id === verticalId) {
      result.push(data);
    }
  });
  return result;
};

const formatRentalHome = (data, pageTitle, type, isVertical) => {
  let rentalData = [];
  let sectionData = [];
  const mediaPath = CommonMapper.extractMediaPath(data);
  const homeData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].page_title === pageTitle
  );
  if (isVertical) {
    sectionData =
      homeData.length > 0 && checkVisionPhilosophyVertical(homeData, type);
  }

  if (sectionData.length > 0) {
    sectionData.map((data, index) => {
      const sectionData = {
        image_mobile: `${mediaPath.mobile}/${data.mobile_image}`,
        tagWord: data.tag_word,
        image_web: `${mediaPath.web}/${data.image}`,
        heading: data.cms_page_details[0].page_title,
        subHeading: data.tag_word,
        description_mobile: data.cms_page_details[0].short_mobile_content,
        description: data.cms_page_details[0].short_content,
      };
      rentalData.push(sectionData);
    });
    return { rentalData, mediaPath };
  }

  return [];
};
const formatMusicFoundation = (data, parentPageTitle, type, isVertical) => {
  let foundationSection = [];
  let sectionData = [];
  const mediaPath = CommonMapper.extractMediaPath(data);
  const musicData = filter(
    data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === parentPageTitle
  );
  if (isVertical) {
    sectionData =
      musicData.length > 0 && checkVisionPhilosophyVertical(musicData, type);
  }

  if (sectionData.length > 0) {
    sectionData.map((data, index) => {
      const sectionData = {
        image_mobile: `${mediaPath.mobile}/${data.mobile_image}`,
        tagWord: data.tag_word,
        image_web: `${mediaPath.web}/${data.image}`,
        heading: data.cms_page_details[0].page_title,
        subHeading: data.tag_word,
        description_mobile: data.cms_page_details[0].short_mobile_content,
        description: data.cms_page_details[0].short_content,
      };
      foundationSection.push(sectionData);
    });

    return { foundationSection, mediaPath };
  }

  return [];
};
const formatVisionPhilosophy = (data, name, vertical, isVertical) => {
  let visionSection = {};
  let visionSectionMobile = [];
  let sectionData = [];
  const mediaPath = CommonMapper.extractMediaPath(data);
  const visionData = filter(
    data && data.cms_pages,
    ({ cms_page_details }) =>
      cms_page_details.length > 0 &&
      cms_page_details[0].parent_page_title === 'Vision and Philosophy'
  );
  if (isVertical) {
    sectionData =
      visionData && checkVisionPhilosophyVertical(visionData, vertical);
  } else if (!isVertical) {
    sectionData = visionData && checkVisionPhilosophyType(visionData, name);
  }

  if (sectionData.length > 0) {
    for (let i = 0; i < sectionData.length; i++) {
      visionSection[i + 1] = sectionData[i].cms_page_details[0];
      visionSection[i + 1].heading = sectionData[i].tag_word;
      visionSection[i + 1].sub_heading = visionSection[i + 1].page_title;
      visionSection[i + 1].image_web = sectionData[i].image;
      visionSection[i + 1].description = visionSection[i + 1].long_content;
    }

    sectionData.map(data => {
      const sectionData = {
        image: `${mediaPath.mobile}/${data.mobile_image}`,
        tagWord: data.tag_word,
        heading: data.cms_page_details[0].page_title,
        subHeading: data.tag_word,
        description: data.cms_page_details[0].short_mobile_content,
      };
      visionSectionMobile.push(sectionData);
    });

    return { visionSection, visionSectionMobile, mediaPath };
  }

  return [];
};

const checkVisionPhilosophyVertical = (visionData, vertical) => {
  let sectionData = [];
  let verticalName = [];
  visionData.map(item => {
    verticalName = StringUtil.sliceHtml(
      item.vertical && item.vertical.vertical_name
    );
    let name = StringUtil.lowerCaseString(verticalName);
    if (name.includes(vertical)) {
      sectionData.push(item);
    }
  });

  return sectionData;
};

const checkVisionPhilosophyType = (visionData, name) => {
  let sectionData = [];
  if (name === 'about') {
    sectionData = visionData.filter(data => data.show_in_about === 'Yes');
  }
  if (name === 'property') {
    sectionData = visionData.filter(
      data => data.show_in_property_management === 'Yes'
    );
  }
  if (name === 'design') {
    sectionData = visionData.filter(
      data => data.show_in_think_design === 'Yes'
    );
  }
  if (name === 'loyalty') {
    sectionData = visionData.filter(
      data => data.show_in_loyalty_program === 'Yes'
    );
  }

  return sectionData;
};

export const CmsPagesSelector = {
  getPageData,
  getPageDataMobile,
  getPageDataLoading,
  getPageDataError,
  getOurDifferenceSection,
  isCmsPageLoading,
  getCampaignDataMobile,
  getVisionPhilosophy,
  getCmsPages,
  getMusicFoundation,
  getRentalHome,
};
